export default {
  'actions.login': 'Anmelden',
  'actions.logout': 'Abmelden',
  'actions.register': 'Registrieren',
  'actions.resetPassword': 'Passwort zurücksetzen',
  'actions.sendVerificationEmail': 'Bestätigungs-E-Mail senden',
  'actions.verifyEmail': 'E-Mail bestätigen',
  'actions.create': 'Erstellen',
  'actions.view': 'Ansehen',
  'actions.viewAll': 'Alle ansehen',
  'actions.viewDetails': 'Details ansehen',
  'actions.assign': 'Zuweisen',
  'actions.unAssign': 'Zuweisung aufheben',
  'actions.assignAll': 'Alle zuweisen',
  'actions.unAssignAll': 'Alle Zuweisungen aufheben',
  'actions.unassigned': 'Nicht zugewiesen',
  'actions.generate': 'Generieren',
  'actions.manage': 'Verwalten',
  'actions.change': 'Ändern',
  'actions.sendMessage': 'Senden',
  'actions.sort': 'Sortieren',
  'actions.ok': 'Ok',
  'actions.publish': 'Veröffentlichen',
  'actions.refresh': 'Aktualisieren',
  'actions.draft': 'Entwurf',
  'actions.hide': '{{type}} ausblenden',
  'actions.unHide': '{{type}} anzeigen',
  'actions.like': 'Gefällt mir',
  'actions.unLike': 'Gefällt mir nicht mehr',
  'actions.more': 'Mehr',
  'actions.time': 'Zeit',
  'actions.share': 'Teilen',
  'actions.shareOn': 'Auf {{type}} teilen',
  'actions.export': 'Exportieren',
  'actions.edit': '{{type}} bearbeiten',
  'actions.show': '{{type}} anzeigen',
  'actions.showOnMap': 'Auf Karte anzeigen',
  'actions.download': 'Datei herunterladen',
  'actions.exportAs': 'Als {{type}} exportieren',
  'actions.email': 'E-Mail senden',
  'actions.copy': 'Kopieren',
  'actions.copied': 'Kopiert',
  'actions.save': 'Speichern',
  'actions.activate': 'Aktivieren',
  'actions.deactivate': 'Deaktivieren',
  'actions.preview': 'Vorschau',
  'actions.hold': 'Pausieren',
  'actions.delete': 'Löschen',
  'actions.deleteEntity': '{{type}} löschen',
  'actions.update': 'Aktualisieren',
  'actions.upload': 'Hochladen',
  'actions.reload': 'Neu laden',
  'actions.screenshot': 'Screenshot',
  'actions.views': 'Aufrufe',
  'actions.close': 'Schließen',
  'actions.confirm': 'Bestätigen',
  'actions.add': '{{type}} hinzufügen',
  'actions.back': 'Zurück',
  'actions.cancel': 'Abbrechen',
  'actions.select': 'Auswählen',
  'actions.unselect': 'Auswahl aufheben',
  'actions.setAs': 'Als {{type}} festlegen',
  'actions.search': 'Suchen',
  'actions.new': 'Neu',
  'actions.next': 'Weiter',
  'actions.prev': 'Zurück',
  'actions.yes': 'Ja',
  'actions.no': 'Nein',
  'actions.leave': 'Verlassen',
  'actions.stay': 'Bleiben',
  'actions.clone': 'Klonen',
  'actions.cloneEntity': '{{type}} klonen',
};
